<ion-header>
  <ion-toolbar color="primary">
    <ion-title class="ion-text-center">
      Detalles de Sesión
    </ion-title>
    <ion-buttons slot="end" class="buttons-end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid fixed>
    <ion-row *ngIf="postUid">
      <ion-col size="12">
        <ion-item lines="none" class="item-transparente summary-card" style="--padding-start: 0; --inner-padding-end: 0; margin-bottom: 8px; background-color: none !important;">
          <ion-thumbnail slot="start" *ngIf="postDetails?.image" style="--size: 72px;">
            <img [src]="postDetails.image" alt="Imagen del post" />
          </ion-thumbnail>
          <ion-thumbnail slot="start" *ngIf="!postDetails?.image" style="--size: 72px;">
            <img src="assets/icon/default-image.png" alt="Sin imagen" />
          </ion-thumbnail>
          <ion-label class="ion-text-wrap">
            <h2 style="font-size: 15px; font-weight: 600;">{{ postDetails?.title || 'Sin título' }}</h2>
            <p>
              <strong>UID:</strong> {{ postDetails?.uid }}
            </p>
            <p style="font-size: 12px; color: #666; margin-top: 4px;">
              {{ postDetails?.publication_date?.toDate ? (postDetails?.publication_date?.toDate() | date:'dd/MM/yyyy HH:mm') : (postDetails?.publication_date | date:'dd/MM/yyyy HH:mm') }}
            </p>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <div class="summary-card" [class.empty]="confirmationList.length === 0">
          <div class="summary-icon">
            <ion-icon name="checkmark-circle-outline"></ion-icon>
          </div>
          <div class="summary-content">
            <p class="summary-label">Total de <br> confirmaciones</p>
            <h2 class="summary-value">{{ confirmationList.length }}</h2>
          </div>
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="summary-card" [class.empty]="assistanceList.length === 0">
          <div class="summary-icon">
            <ion-icon name="people-outline"></ion-icon>
          </div>
          <div class="summary-content">
            <p class="summary-label">Total de <br> asistentes</p>
            <h2 class="summary-value">{{ assistanceList.length }}</h2>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="6">
        <ion-button expand="block" fill="clear" (click)="exportReport('confirmations')">
          Descargar Confirmaciones
          <ion-icon name="download-outline" slot="end"></ion-icon>
        </ion-button>
      </ion-col>
      <ion-col size="6">
        <ion-button expand="block" fill="clear" (click)="exportReport('assistants')">
          Descargar Asistentes
          <ion-icon name="download-outline" slot="end"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">
        <div class="chart-card">
          <ag-charts-angular *ngIf="summaryChartOptions" [options]="summaryChartOptions"
            style="width: 100%; height: 320px;"></ag-charts-angular>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="12">&nbsp;</ion-col>
    </ion-row>
  </ion-grid>
</ion-content>